import { defineStore } from 'pinia'
import escape2html from '@/api/escape2html'

const { toHtml } = escape2html();

export const userinfo = defineStore({
  id: 'user',
  state: () => ({
    login: true,//登陆状态则为true
    signup: false,//想要注册则为true
    showUser: false,//用户信息显示
    baseInfo: {
      id: '',
      address: '',//区域
      career: '',
      nickname: '' || "未登录",
      telephone: '',
      status: NaN
    },
    comments: [] as any,
    details: {} as Record<number, any>,
    pics: {} as Record<number, any>,
    pages: {
      home: {
        list: [] as number[],
        page: 1,
        total: 0,
      },
      sub: {
        list: [] as number[],
        page: 1,
        total: 0,
        cate: -1,
      },
      search: {
        list: [] as number[],
        page: 1,
        total: 0
      },
      saying: {
        intro: "",
        page: 1,
        total: 0,
        list: [] as any[],
      },
      podcast: {
        intro: "",
        page: 1,
        total: 0,
        list: [] as any[],
      },
      res: {
        intro: "",
        page: 1,
        total: 0,
        list: [] as any[],
      },
      roomIntro:"",
    },
    resources: {} as Record<number, any>,
    curArticle: '' as any,
    curComment: '' as any,
    notices: [] as any,
    hotDisscussions: [] as any,
    discussionCates: [] as any,
    knowNickName: [] as any,
    enrolledNotices: null as any,
  }),
  getters: {
    articleNum: (state) => Math.min(state.pages.home.list.length, state.pages.home.total),
    subArticleNum: (state) => Math.min(state.pages.sub.list.length, state.pages.sub.total),
    searchArticleNum: (state) => Math.min(state.pages.search.list.length, state.pages.search.total),
    curHtml: (state) => {
      if (state.curArticle.contentRes == undefined) {
        return ''
      } else {
        return toHtml(state.curArticle.Content)
      }
    }
    // allpages:(state)=>Math.ceil(state.allcount/state.perpage)*10,
    // searchpages:(state)=>Math.ceil(state.searchcount/state.persearch)*10,
    // avartarimg:(state)=>{
    //   if(state.avatar){
    //     return "https://static.tiaozhan.com"+state.avatar
    //   }else{
    //     return tenzor
    //   } 
    // }
    // doubleCount: (state) => state.counter * 2
  },
  actions: {
    increment() {
      // this.counter++
    },
    // getDetailid(article_id: number) {
    //   for (let i = 0; i < this.details.length; i++) {
    //     if(article_id == this.details[i].newsId) return i
    //   }
    //   return -1
    // }
  }
})
